
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ConvertNumber from '../components/ConvertNumber';
import { API_URL } from '../config';
import ParsMonth from '../services/ParsMonth';
import logo_pop from '../assets/images/logo-pop.png';

var participantBuilding = '';
var participantCity = '';
var participantEmail = '';
var participantFirstName = '';
var participantFlat = '';
var participantLastName = '';
var participantPesel = '';
var participantPhone = '';
var participantPostalCode = '';
var participantStreet = '';
var contractSygnature = localStorage.getItem('contractSygnature')
var discountName = localStorage.getItem('discountName')
let today = new Date();
let date = today.getDate() + '-' + parseInt(today.getMonth() + 1) + '-' + today.getFullYear();
const parsMonth = ParsMonth.getInstance();

const AppContractSchedule = ({
    getGroup,
    coursesHeadings,
    allInstallments
}) => {
    const userGetURL = `${API_URL}UserGet`;
    const getPriceByCourseHeadingsIdURL = `${API_URL}GetPriceByCourseHeadingsID`;
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const [formData] = useState({
        coursesHeadingsID: `${localStorage.getItem('coursesHeadingsID')}`,
        startDate: `${localStorage.getItem('startDate')}`,
        current_LocalizationsID: -1,
    });
    const [res, setRes] = useState([]);

    function parse(numberMonth) {
        let date = (numberMonth[5] > 0 ? numberMonth[5] : '') + numberMonth[6];
        let respons = parsMonth.manth.find((e) => e.valueID === +date);
        return respons.name;
    }


    function paymentsMetod(method) {
        if (method.periodsOfValidityDVID === 1) {
            return 'Roczna '+ method.paymentDVIDName
        } else
            if (method.periodsOfValidityDVID === 2) {
                return 'Semestralna '+ method.paymentDVIDName
            } else
                if (method.periodsOfValidityDVID === 3) {
                    return 'Miesięczna '+ method.paymentDVIDName
                }
        return ''
    }

    useEffect(() => {
        axios
            .get(userGetURL, config)
            .then((response) => {

                participantBuilding = response.data.building;
                participantCity = response.data.city;
                participantEmail = response.data.email;
                participantFirstName = response.data.firstName;
                participantFlat = response.data.flat;
                participantLastName = response.data.lastName;
                participantPesel = response.data.pesel;
                participantPhone = response.data.phone;
                participantPostalCode = response.data.postalCode;
                participantStreet = response.data.street;
                setRes(allInstallments);
            })
            .catch(function (error) {
                console.log('get error response', error);
            });
    }, []);

    return getGroup ? (
        <>
 
            <div className="generated-contract">
                <div className="partPdf">
                    <div className="contractLogoWraper">
                    <img src={logo_pop} alt="Logo Egurrola Dance Studio" className="generated-contract__logo" />
                    </div>
                    <h1>Wzór harmonogramu do umowy</h1>
                    <h2>
                       {"Nr/YZ"}
                    </h2>
                </div>
                <div className="generated-contract__clauses">
                    <div className="partPdf">
                        
                        {/* <p>
                        1. Strony ustalają iż na dzień zawarcia Aneksu, Uczestnik spełnia warunki Promocji "Promocja 10% na wszystkie raty" opisane w Regulaminie Promocji dostępnym w placówkach EDS. 
                        </p>
                        <p>
                        2. W następstwie warunków opisanych w pkt. 1 Uczestnik otrzymuje zniżkę zgodnie z tabelą na zajęcia regularne które stanowią przedmiot Umowy numer . 
                        </p> */}
                    </div>

                 </div>

                <div className="partPdf">
               
                    <p className="generated-contract__row generated-contract__table-caption">
                    Wykaz zniżek w poszczególnych miesiącach*:
                    </p>
                    
                    <table className="generated-contract__table__max">
                        <thead>
                            <tr>
                                <th>Lp</th>
                                <th>Kwota bazowa</th>
                                <th>Rabat procentowy</th>
                                <th>Rabat kwotowy</th>
                                <th>Kwota po rabatach</th>
                                <th>Miesiąc</th>  
                                <th>Termin płatności</th>
                            </tr>
                        </thead>  
                        <tbody>
                            {res.map((el, index) =>
                               
                                (el.paymentPositionPrice > 0 || el.discountProcent == 100) ? (
                                <tr>
                                    <td id="installment-number-01" className="installment-number">
                                        {index + 1}
                                    </td>
                                    <td id="installment-sum-01" className="installment-sum">
                                        {ConvertNumber(el.paymentPositionPrice) } zł
                                    </td>
                                     <td id="installment-sum-01" className="installment-sum">
                                        {ConvertNumber(el.discountProcent) } %
                                    </td>
                                    <td id="installment-sum-01" className="installment-sum">
                                        {ConvertNumber(el.discountCash) } zł
                                    </td>
                                    <td id="installment-sum-01" className="installment-sum">
                                        {ConvertNumber(el.paymentPositionPriceDiscount) } zł
                                    </td>
                                    <td id="installment-sum-01" className="installment-sum">
                                            {parse(el.paymentDate)}
                                    </td>  
                                    <td id="installment-date-01" className="installment-date">
                                          {el.paymentDate}
                                    </td>
                                </tr> 
                                ) : (
                                    ''
                                )
                            )}
 
                        </tbody>
                    </table>
                </div>
                <div className="generated-contract__clauses">
                    <div className="partPdf">
                         
                        <p>
                        * Harmonogram zniżek został wygenerowany przy założeniu że Uczestnik będzie spełniał warunki promocji "{discountName}" do końca trwania Umowy
                        </p>
                    </div>

                </div>

                <div className="partPdf">
                    {/* Agreement */}
                    <div className="generated-contract__agreement">
                        <div className="generated-contract__signatures">
                            <div className="generated-contract__signature">
                                <span>Data i podpis w imieniu EDS</span>
                            </div>
                            <div className="generated-contract__signature">
                                <span>Data i podpis Klienta</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ''
    );
};
export default AppContractSchedule;
